import React, { useState, useRef } from "react";
import { Card, Form, Table, Button, Row, Col } from "react-bootstrap";
import { AsyncTypeahead, Highlighter } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { DateFormat } from "../Helper";
import moment from "moment";
import patientService from "../services/patient.service";
import { toast } from "react-toastify";

function AllocateService({
  adviceType,
  id,
  typeaheadId,
  fields,
  thGroups,
  variant,
  adviceNoted,
  setAdviceNoted,
  kapid_user_id,
}) {
  const [serviceFormValidated, setServiceFormValidated] = useState(false);

  const adviceRef = useRef({});
  const [typeAheadSelection, setTypeAheadSelection] = useState([]);

  const handleSearch = async (query) => {
    try {
      // Make your API request here to fetch options based on the query
      const data = await patientService.searchService(query);
      if (data === false) throw new Error("Something went wrong");

      setTypeAheadSelection(data);
      return data;
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  const handleSymptomItemSelect = (selectedItem) => {
    setTypeAheadSelection((prevState) => selectedItem);
    if (selectedItem.length > 0) {
      const item = selectedItem[0];
      adviceRef.current.item_base_price.innerHTML = item.base_price;
      adviceRef.current["gst_rate"].innerHTML = item.gst_percent;
      adviceRef.current["discount_limit"].innerHTML = item.discount_limit || 0;
      adviceRef.current["item_quantity"].focus();
      calculatePrice(item);
    }
  };
  const handleAdviceAdd = (e) => {
    e.preventDefault();
    let error = false;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      error = true;
    }
    setServiceFormValidated(true);
    if (error) return false;
    let itemSelected;
    itemSelected = typeAheadSelection[0];
    // const bp = localdataService.getDefaultBp();
    const item = {
      kapid_user_id: kapid_user_id,
      item_type: "service",
      item_quantity: itemSelected.item_quantity,
      item_unit_id: itemSelected.bp_item_unit_id,
      item_source_id: itemSelected.bp_service_id,
      item_base_price: itemSelected.base_price,
      item_discount_rate: itemSelected.item_discount_rate,
      item_discount_amount: itemSelected.item_discount_amount,
      taxable_amount: itemSelected.taxable_amount,
      gst_rate: itemSelected.gst_percent,
      gst_amount: itemSelected.gst_amount,
      // gst_breakup: [],
      unit_net_price: round(itemSelected.subtotal / itemSelected.item_quantity),
      subtotal: itemSelected.subtotal,
      avail_date: adviceRef.current.date.value,
      created_date: adviceRef.current.date.value,
      note: adviceRef.current["note"].value,
      timestamp: Date.now(),
      bp_sys_id: itemSelected.bp_sys_id,
      bp_br_id: itemSelected.bp_br_id,
      bp_service_name: itemSelected.bp_service_name,
      item_service_details: { bp_service_name: itemSelected.bp_service_name },
    };

    form.reset();
    adviceRef.current.search.clear();
    resetAllocationForm();
    setTypeAheadSelection([]);

    setAdviceNoted(
      [...adviceNoted, item].sort((a, b) =>
        a.avail_date < b.avail_date ? 1 : -1
      )
    );
    setServiceFormValidated(false);
  };

  const handleAdviceUpdate = (timestamp) => {
    var oldAdvice = adviceNoted.find((s) => s.timestamp === timestamp);
    // oldAdvice.canceled = true;
    let newNotedSymptoms = adviceNoted.filter((s) => s.timestamp !== timestamp);
    setAdviceNoted(
      [...newNotedSymptoms, { ...oldAdvice, canceled: true }].sort((a, b) =>
        a.timestamp < b.timestamp ? 1 : -1
      )
    );
    handleExpandRow(timestamp);
  };

  const [expandedRows, setExpandedRows] = useState([]);
  // State variable to keep track which row is currently expanded.
  const [expandState, setExpandState] = useState({});
  const [editSelected, setEditSelected] = useState({});

  const handleEditSearch = async (query, timestamp) => {
    try {
      // Make your API request here to fetch options based on the query
      const data = await patientService.searchService(query);
      if (data === false) throw new Error("Something went wrong");

      setEditSelected({ ...editSelected, [timestamp]: data });
      return data;
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  const handleAdviceEditSelection = (selected, timestamp) => {
    if (selected.length > 0) {
      adviceRef.current[`rate_${timestamp}`].value = selected[0].rate;
      calculatePrice(null, timestamp);
    }

    setEditSelected({ ...editSelected, [timestamp]: selected });
  };

  const handleExpandRow = (timestamp) => {
    const currentExpandedRows = expandedRows;
    const isRowExpanded = currentExpandedRows.includes(timestamp);
    if (isRowExpanded === false)
      setEditSelected({
        ...editSelected,
        [timestamp]: [adviceNoted.find((p) => p.timestamp === timestamp)],
      });
    let obj = expandState;
    isRowExpanded ? (obj[timestamp] = false) : (obj[timestamp] = true);
    setExpandState(obj);

    // If the row is expanded, we are here to hide it. Hence remove
    // it from the state variable. Otherwise add to it.
    let newExpandedRows = [];
    if (isRowExpanded)
      newExpandedRows = currentExpandedRows.filter((row) => row !== timestamp);
    else newExpandedRows = currentExpandedRows.concat(timestamp);

    setExpandedRows(newExpandedRows);
  };
  const handleAdviceEdit = (timestamp) => {
    let obj = expandState;
    obj[timestamp] = "edit";
    setExpandState({ ...obj });
  };
  function round(num, roundof = false) {
    var n = Math.round((num + Number.EPSILON) * 100) / 100;
    return roundof ? Math.round(n) : n;
  }

  function resetAllocationForm() {
    adviceRef.current["item_base_price"].innerHTML = 0;
    adviceRef.current["item_quantity"].value = 1;
    adviceRef.current["item_discount_rate"].value = 0;
    adviceRef.current["discount_limit"].innerHTML = 0;
    adviceRef.current["item_discount_amount"].innerHTML = 0;
    adviceRef.current["taxable_amount"].innerHTML = 0;
    adviceRef.current["gst_rate"].innerHTML = 0;
    adviceRef.current["gst_amount"].innerHTML = 0;
    adviceRef.current["subtotal"].innerHTML = 0;
  }
  const calculatePrice = (selectedItem, timestamp) => {
    if (timestamp === undefined) {
      if (selectedItem === undefined) selectedItem = typeAheadSelection[0];

      let item_quantity = adviceRef.current.item_quantity.value;
      let item_discount_rate = adviceRef.current.item_discount_rate.value;
      let taxable_amount = round(item_quantity * selectedItem.base_price);
      const discount_limit = selectedItem.discount_limit;
      let max_discount = 0;

      if (isNaN(discount_limit)) {
        //discount limit is in percentage
        let dis_per = parseFloat(discount_limit) || 0;
        max_discount = round((taxable_amount * dis_per) / 100);
      } else {
        //flat disocunt
        max_discount = parseFloat(discount_limit) * item_quantity || 0;
      }
      let discount_value = 0;
      if (item_discount_rate.endsWith("%")) {
        let dis_per = parseFloat(item_discount_rate) || 0;
        discount_value = round((taxable_amount * dis_per) / 100);
      } else {
        discount_value = isNaN(item_discount_rate)
          ? 0
          : parseFloat(item_discount_rate) * item_quantity || 0;
      }

      if (discount_value > max_discount) {
        adviceRef.current.item_discount_rate.setCustomValidity(
          "Invalid Value."
        );
        toast.error("Discount exceeding max limit.");
      } else {
        adviceRef.current.item_discount_rate.setCustomValidity("");
      }

      taxable_amount = taxable_amount - discount_value;
      let gst_amount = round((taxable_amount * selectedItem.gst_percent) / 100);
      let subtotal = round(taxable_amount + gst_amount, true);
      adviceRef.current["item_discount_amount"].innerHTML = discount_value;
      adviceRef.current["taxable_amount"].innerHTML = taxable_amount;
      adviceRef.current["gst_amount"].innerHTML = gst_amount;
      adviceRef.current["subtotal"].innerHTML = subtotal;
      selectedItem["item_quantity"] = item_quantity;
      selectedItem["item_discount_rate"] = item_discount_rate;
      selectedItem["item_discount_amount"] = discount_value;
      selectedItem["taxable_amount"] = taxable_amount;
      selectedItem["gst_amount"] = gst_amount;
      selectedItem["subtotal"] = subtotal;
      setTypeAheadSelection([selectedItem]);
    } else {
      let qty = adviceRef.current[`quantity_${timestamp}`].value;
      let rate = adviceRef.current[`rate_${timestamp}`].value;
      adviceRef.current[`subtotal_${timestamp}`].value = qty * rate;
    }
  };
  return (
    <>
      <Card className="mb-3" border={variant} id={id}>
        <Card.Header className={"bg-" + variant + " text-white"} as="h5">
          {adviceType}
        </Card.Header>
        <Card.Body>
          <Form
            noValidate
            validated={serviceFormValidated}
            onSubmit={handleAdviceAdd}
          >
            <fieldset>
              <Row>
                <Col xs={12} sm={12} md={3}>
                  <Form.Group>
                    <Form.Label>Date</Form.Label>
                    <Form.Control
                      ref={(el) => (adviceRef.current["date"] = el)}
                      type="datetime-local"
                      defaultValue={moment().format("yyyy-MM-DD HH:mm")}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>{adviceType}</Form.Label>
                    <AsyncTypeahead
                      renderMenuItemChildren={(option, { text }) => (
                        <>
                          <Highlighter search={text}>
                            {option.bp_service_name}
                          </Highlighter>
                          <div>
                            <small>
                              {option.bp_name}&mdash;{option.bp_branch_name}
                              &mdash;
                              {option.currency} {option.rate}
                            </small>
                          </div>
                        </>
                      )}
                      id="serviceTypeAhead"
                      labelKey="bp_service_name"
                      multiple={false}
                      options={typeAheadSelection}
                      onSearch={handleSearch}
                      onChange={handleSymptomItemSelect}
                      placeholder="Search..."
                      inputProps={{ required: true }}
                      ref={(el) => (adviceRef.current["search"] = el)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Table bordered responsive className="text-end">
                <colgroup>
                  <col
                    style={{ width: "12.5%", textAlign: "right" }}
                    className="text-end"
                  />
                  <col style={{ width: "12.5%", textAlign: "right" }} />
                  <col style={{ width: "12.5%", textAlign: "right" }} />
                  <col style={{ width: "12.5%", textAlign: "right" }} />
                  <col style={{ width: "12.5%", textAlign: "right" }} />
                  <col style={{ width: "12.5%", textAlign: "right" }} />
                  <col style={{ width: "12.5%", textAlign: "right" }} />
                  <col style={{ width: "12.5%", textAlign: "right" }} />
                </colgroup>
                <thead>
                  <tr>
                    <th>Base Price</th>
                    <th>Quantity</th>
                    <th>Discount Rate</th>
                    <th>Discount</th>
                    <th>Taxable</th>
                    <th>GST Rate</th>
                    <th>GST Amount</th>
                    <th>Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      ref={(el) => (adviceRef.current["item_base_price"] = el)}
                      className="text-end"
                    >
                      {0.0}
                    </td>
                    <td>
                      <Form.Control
                        className="border-0 text-end"
                        ref={(el) => (adviceRef.current["item_quantity"] = el)}
                        type="number"
                        min={1}
                        defaultValue={1}
                        required
                        onChange={(e) => {
                          calculatePrice();
                        }}
                      ></Form.Control>
                    </td>
                    <td>
                      <Form.Group>
                        <Form.Control
                          className="border-0 text-end"
                          // pattern="^\d+(\.\d{1,2})?$"
                          pattern="^\d+(\.\d+)?%?$"
                          ref={(el) =>
                            (adviceRef.current["item_discount_rate"] = el)
                          }
                          defaultValue={0.0}
                          onChange={(e) => {
                            calculatePrice();
                          }}
                        ></Form.Control>
                        <small className="d-none d-lg-block">
                          Max Discount :{" "}
                          <strong
                            ref={(el) =>
                              (adviceRef.current["discount_limit"] = el)
                            }
                          >
                            0
                          </strong>
                        </small>
                      </Form.Group>
                    </td>
                    <td
                      className="text-end"
                      ref={(el) =>
                        (adviceRef.current["item_discount_amount"] = el)
                      }
                    >
                      {0.0}
                    </td>
                    <td
                      className="text-end"
                      ref={(el) => (adviceRef.current["taxable_amount"] = el)}
                    >
                      {0.0}
                    </td>
                    <td
                      className="text-end"
                      ref={(el) => (adviceRef.current["gst_rate"] = el)}
                      defaultValue={0.0}
                    >
                      {0.0}
                    </td>
                    <td
                      className="text-end"
                      ref={(el) => (adviceRef.current["gst_amount"] = el)}
                    >
                      {0.0}
                    </td>
                    <td
                      className="text-end"
                      ref={(el) => (adviceRef.current["subtotal"] = el)}
                      defaultValue={0.0}
                    >
                      {0.0}
                    </td>
                  </tr>
                  {/* {typeAheadSelection.length == 1 && (
                  )}
                  {typeAheadSelection.length === 0 && (
                    <tr>
                      <td colSpan={8} className="text-center">
                        Select a service
                      </td>
                    </tr>
                  )} */}
                </tbody>
              </Table>
              <Form.Group className="mb-3">
                <Form.Label>Note</Form.Label>
                <Form.Control
                  as="textarea"
                  row={4}
                  ref={(el) => (adviceRef.current["note"] = el)}
                />
              </Form.Group>
              <Form.Group className="text-end mb-3">
                <Button type="submit" variant="outline-primary">
                  Add
                </Button>
              </Form.Group>
            </fieldset>
          </Form>
          <Table bordered className="text-end">
            <thead>
              <tr>
                <th className="text-start">Date</th>
                <th className="text-start">Name</th>
                <th>Net Rate</th>
                <th>Quantity</th>
                <th>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {adviceNoted
                .filter((a) => a.canceled !== true)
                .map((advice) => {
                  return (
                    <React.Fragment key={advice.timestamp}>
                      <tr
                        role="button"
                        onClick={() => handleExpandRow(advice.timestamp)}
                        className={
                          expandState[advice.timestamp] === true
                            ? "table-warning"
                            : expandState[advice.timestamp] === "edit"
                            ? "table-danger"
                            : ""
                        }
                      >
                        <td className="text-start">
                          <DateFormat value={advice.created_date} />
                        </td>
                        <td className="text-start">
                          <strong>
                            {advice.item_service_details.bp_service_name}
                          </strong>
                        </td>
                        <td>{advice.unit_net_price}</td>
                        <td>{advice.item_quantity}</td>
                        <td>{advice.subtotal}</td>
                      </tr>
                      {expandedRows.includes(advice.timestamp) && (
                        <tr>
                          <td colSpan={5}>
                            <Table bordered responsive className="text-end">
                              <colgroup>
                                <col
                                  style={{ width: "12.5%", textAlign: "right" }}
                                  className="text-end"
                                />
                                <col
                                  style={{ width: "12.5%", textAlign: "right" }}
                                />
                                <col
                                  style={{ width: "12.5%", textAlign: "right" }}
                                />
                                <col
                                  style={{ width: "12.5%", textAlign: "right" }}
                                />
                                <col
                                  style={{ width: "12.5%", textAlign: "right" }}
                                />
                                <col
                                  style={{ width: "12.5%", textAlign: "right" }}
                                />
                                <col
                                  style={{ width: "12.5%", textAlign: "right" }}
                                />
                                <col
                                  style={{ width: "12.5%", textAlign: "right" }}
                                />
                              </colgroup>
                              <thead>
                                <tr>
                                  <th>Base Price</th>
                                  <th>Quantity</th>
                                  <th>Discount Rate</th>
                                  <th>Discount</th>
                                  <th>Taxable</th>
                                  <th>GST Rate</th>
                                  <th>GST Amount</th>
                                  <th>Subtotal</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="text-end">
                                    {advice.item_base_price}
                                  </td>
                                  <td className="text-end">
                                    {advice.item_quantity}
                                  </td>
                                  <td className="text-end">
                                    {advice.item_discount_rate}
                                  </td>
                                  <td className="text-end">
                                    {advice.item_discount_amount}
                                  </td>
                                  <td className="text-end">
                                    {advice.taxable_amount}
                                  </td>
                                  <td className="text-end">
                                    {advice.gst_rate}%
                                  </td>
                                  <td className="text-end">
                                    {advice.gst_amount}
                                  </td>
                                  <td className="text-end">
                                    {advice.subtotal}
                                  </td>
                                </tr>
                                {advice.note && advice.note.trim() !== "" && (
                                  <tr>
                                    <td colSpan={8} className="text-start">
                                      {advice.note}
                                    </td>
                                  </tr>
                                )}
                                <tr>
                                  <td colSpan={8} className="text-end">
                                    <Button
                                      type="button"
                                      variant="outline-primary"
                                      className="ms-3"
                                      onClick={() =>
                                        handleExpandRow(advice.timestamp)
                                      }
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      type="button"
                                      className="ms-3"
                                      variant="outline-danger"
                                      onClick={() =>
                                        handleAdviceUpdate(advice.timestamp)
                                      }
                                    >
                                      Remove
                                    </Button>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </>
  );
}

export default AllocateService;
